// extracted by mini-css-extract-plugin
export default {"loaderSpinner":"PreLoader_loaderSpinner__onYbe","preLoader":"PreLoader_preLoader__jh6xZ"};